import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    display: Boolean,
    userId: Number,
    editableUntil: Number
  }

  connect() {
    if (this.userIdValue != window.currentUserId) { return }
    if (!this.currentlyEditable) { return }

    this.element.classList.remove('!hidden')

    const interval = setInterval(() => {
      if (!this.currentlyEditable) {
        clearInterval(interval)
        this.element.classList.add('!hidden')
      }
    }, 5000)
  }

  setInitialVisibility() {
    if (this.userIdValue != window.currentUserId) { return }
    if (!this.currentlyEditable) { return }
  }

  get currentlyEditable() {
    return this.editableUntilValue > new Date().getTime() / 1000
  }
}
